// 'smartLearning' session type is used for analytics only
export const SESSION_TYPES = Object.freeze({
  adaptive: "adaptive",
  wrongAnswers: "wrongAnswers",
  smartLearning: "smartLearning",
  notesOnly: "notesOnly",
  quiz: "quiz"
});

export type SessionType = keyof typeof SESSION_TYPES;
